import { colors } from '../../constants';

export const Pill = ({ children, style, green, greenLight, blue, blueLight, size }) => {
  let extraStyle = { ...style };

  if (blue) {
    extraStyle = {
      ...extraStyle,
      borderColor: colors.brightBlue + '88',
      background: colors.lightBlue,
      color: colors.brightBlue,
    };
  }

  if (blueLight) {
    extraStyle = {
      ...extraStyle,
      background: colors.brightBlue,
      color: 'white',
    };
  }

  if (green) {
    extraStyle = {
      ...extraStyle,
      borderColor: colors.brightGreen,
      background: colors.lightGreen,
      color: colors.brightGreen,
    };
  }

  if (greenLight) {
    extraStyle = {
      ...extraStyle,
      background: colors.lightGreen,
      color: colors.brightGreen,
    };
  }

  if (size == 'sm') {
    extraStyle = {
      ...extraStyle,
      borderRadius: 4,
      padding: '1px 4px 2px 4px',
    };
  }

  return (
    <div
      style={{
        border: '1px solid #888',
        background: '#eee',
        display: 'inline-block',
        fontSize: 12,
        padding: '1px 8px 2px 8px',
        borderRadius: 12,
        ...extraStyle,
      }}
    >
      {children}
    </div>
  );
};
